import { HttpClient, HttpParams } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var GenerateIndustryReportService = /** @class */ (function () {
    function GenerateIndustryReportService(http) {
        this.http = http;
    }
    GenerateIndustryReportService.prototype.generateIndustryReport = function (month) {
        return this.http.get('dealers/reports/industry/generate/', {
            params: new HttpParams().set('month', this.formatDate(month)),
            responseType: 'text'
        });
    };
    GenerateIndustryReportService.prototype.formatDate = function (date) {
        var month = date.month, year = date.year;
        return year.toString() + '-' + (month > 9 ? month.toString() : '0' + month.toString());
    };
    GenerateIndustryReportService.ngInjectableDef = i0.defineInjectable({ factory: function GenerateIndustryReportService_Factory() { return new GenerateIndustryReportService(i0.inject(i1.HttpClient)); }, token: GenerateIndustryReportService, providedIn: "root" });
    return GenerateIndustryReportService;
}());
export { GenerateIndustryReportService };
